<template>

  <div class="it" :to="props.link">

    <NuxtLink class="icon" :to="props.link">
      <img loading="lazy" class="icon-img" :src="props.icon" :alt="props.name">
    </NuxtLink>

    <NuxtLink class="name" :to="props.link">
      {{ props.name }}
    </NuxtLink>

    <div class="desc" v-html="formatCommonText(props.description)">
    </div>


  
  </div>
</template>



<script setup lang="ts">

import { formatCommonText } from '@/types/other';

interface PageProps {
  icon: string;
  link: string;
  name: string;
  description: string;
}

const props = defineProps<PageProps>();

 
 
</script>

<style scoped>
 
.it{
  display: grid;
  grid-template-columns: 100px 1fr;
  grid-template-areas: 
    "icon name"
    "icon desc";
  gap: 0.2rem 2rem;
  margin-bottom: 2rem;
}
.icon{
  grid-area: icon;
  width: 100%;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
.name{
  grid-area: name;
  font-size: 1.1rem;
  font-weight: bold;
  color: var(--color-text);
}
.desc{
  grid-area: desc;
  color: var(--color-text);
}
.desc:deep(p){
  margin: 0;
}

@container pb (max-width: 600px) {
  .it{
    grid-template-columns: 60px 1fr;
    grid-template-areas: 
      "icon name"
      "desc desc";
    gap: 0.5rem 1rem;
  }
  .icon{
    max-width: 200px;
  }
  .name{
    display: flex;
    align-items: center;

  }
}




</style>